/* Bounds the shared tlui-cmt-list inside the popover so its items scroll. */
.wrap {
	display: flex;
	flex-direction: column;
	width: 300px;
	max-width: 92vw;
	max-height: 60vh;
}

/* The author-coloured comment pin leading each row — the SDK pin silhouette (.tlui-cmt-pin),
   filled solid rather than holding an avatar. Colour set inline from the author's colour. */
.pin {
	align-self: flex-start;
	margin-top: 2px;
	flex-shrink: 0;
	width: 16px;
	height: 16px;
	border-radius: 50% 50% 50% 0;
	background: var(--tl-color-text-3);
}

.head {
	display: flex;
	align-items: baseline;
	gap: 8px;
}

/* The headline: the name-led reason it's a notification, wrapping so it stays fully readable. */
.byline {
	flex: 0 1 auto;
	min-width: 0;
	font-size: 13px;
	color: var(--tl-color-text-3);
}

.author {
	font-weight: 600;
	color: var(--tl-color-text-1);
	/* a single absurd display name must not eat the row: ellipsize each name span */
	display: inline-block;
	max-width: 9em;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	vertical-align: bottom;
}

.time {
	flex-shrink: 0;
	font-size: 11px;
	color: var(--tl-color-text-3);
}

.preview {
	margin-top: 2px;
	font-size: 12px;
	color: var(--tl-color-text-3);
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	word-break: break-word;
}

/* Unread marker on a row — the same blue as the sidebar bell's badge, pinned top-right. */
.unreadDot {
	align-self: flex-start;
	margin-top: 5px;
	flex-shrink: 0;
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background-color: var(--tl-color-selected);
}

/* Small dot on the sidebar bell when there are unread notifications. */
.badge {
	position: absolute;
	top: 8px;
	right: 8px;
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background-color: var(--tl-color-selected);
	box-shadow: 0 0 0 2px var(--tla-color-sidebar);
	pointer-events: none;
}
